import { ACCESS_ALL, ACCESS_SELECTED } from './school_access_section';

// Copying one product's school list onto the other's (Spark → Pulse, or Pulse → Spark).
//
// A viewer is very often set up for one product first and then wants the same schools for the
// other; retyping the list is the error-prone step. Both the offer ("is there anything to copy?")
// and the confirmation wording ("what exactly is about to be overwritten?") are pure functions so
// they can be unit tested — this project's front-end tests have no DOM, so any logic worth
// asserting has to live outside the component (same reasoning as the Spark render tests).

const pluralizeSchools = (count) => `${count} school${count === 1 ? '' : 's'}`;

// Whether the OTHER product has a list worth copying. Only an explicit "Selected schools only"
// list qualifies: "All schools" is a flag rather than a list, and "No access" has nothing to give.
export const isCopyableSource = (mode, schools) => mode === ACCESS_SELECTED && schools.length > 0;

// The confirmation the user sees before anything is overwritten. `replaces` is the sentence that
// names what is lost — null when the destination has nothing to lose, so we don't invent a warning.
export const describeCopy = ({ sourceProduct, sourceSchools, destProduct, destMode, destSchools }) => {
  const summary = `${destProduct} Report Access will be set to the ${pluralizeSchools(sourceSchools.length)} currently selected for ${sourceProduct} Report Access.`;

  let replaces = null;
  if (destMode === ACCESS_ALL) {
    replaces = `${destProduct} Report Access is currently set to All schools — it will change to Selected schools only.`;
  } else if (destMode === ACCESS_SELECTED && destSchools.length > 0) {
    replaces = `The ${pluralizeSchools(destSchools.length)} now listed under ${destProduct} Report Access will be replaced.`;
  }

  return {
    title: `Copy schools from ${sourceProduct}?`,
    summary,
    replaces,
    schools: [...sourceSchools],
  };
};
